import React, { useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Link } from "react-router-dom";

function Branding() {
const [openIndex, setOpenIndex] = useState<number | null>(0);

const toggleAccordion = (index: number) => {
setOpenIndex(openIndex === index ? null : index);
};

const services = [
{
title: "Brand Strategy & Positioning",
content:
"We help brands define who they are, what they stand for, and why they matter. Our brand strategy process dives deep into market research, audience insights, competitor analysis, and brand purpose to create a strong positioning framework. From brand vision and mission to tone of voice and value propositions, we build a strategic foundation that aligns business goals with customer expectations.",
},
{
title: "Logo Design & Visual Identity",
content:
"A logo is not just a mark—it's the face of your brand. We design distinctive, memorable logos supported by a cohesive visual identity system including colour palettes, typography, iconography, and graphic elements. Every design decision is rooted in strategy and scalability, ensuring consistency across digital, print, and physical touchpoints.",
},
{
title: "Brand Guidelines & Playbooks",
content:
"Consistency builds trust. We create comprehensive brand guidelines that serve as a single source of truth for your brand. From logo usage rules and typography systems to colour specifications, imagery styles, and tone of voice, our playbooks ensure your brand looks and sounds the same everywhere.",
},
{
title: "Packaging & Label Design",
content:
"Packaging is often the first physical interaction customers have with your brand. We design packaging that not only looks attractive on shelves but also communicates value, quality, and brand story instantly. Our approach balances aesthetics, functionality, compliance, and sustainability considerations.",
},
{
title: "Rebranding & Brand Refresh",
content:
"When brands evolve, their identity must evolve too. We help businesses rebrand or refresh their identity without losing their core essence. From subtle visual refinements to complete identity overhauls, we ensure the transition feels strategic, seamless, and credible.",
},
{
title: "Naming & Brand Architecture",
content:
"A powerful name sets the tone for everything that follows. We develop brand names, sub-brands, and product naming systems that are meaningful, distinctive, and legally viable. Our naming process blends creativity with strategy, linguistics, and market relevance.",
},
];

return (


<>
  <section
    className="container"
    style={{
      paddingTop: "80px",
      paddingBottom: "80px",
    }}
    >
    <p
        style={{
          marginTop: "20px",
          fontSize: "16px",
          color: "#888",
        }}
      >
        <Link to="/" style={{ color: "#111", textDecoration: "none" }}>
          Home
        </Link>

        {" / "}

        <Link
          to="/services"
          style={{ color: "#111", textDecoration: "none" }}
        >
          Services
        </Link>

        {" / "} Branding & Identity Design
      </p>
  
    <h1
      style={{
        marginTop: "40px",
        fontSize: "80px",
        lineHeight: "1.1",
        marginBottom: "100px",
      }}
    >
      <span style={{ fontWeight: "400" }}>
        Branding
      </span>

      <br />

      <span style={{ fontWeight: "100" }}>
        & Identity Design
      </span>
    </h1>
    <div
  style={{
    display: "flex",
    alignItems: "center",
    gap: "20px",
    marginTop: "40px",
    marginBottom: "90px",
  }}
>
  <span
    style={{
      fontSize: "20px",
      fontWeight: "400",
      color: "#111",
    }}
  >
    About service
  </span>

  <a
    href="#about-service"
    style={{
      width: "48px",
      height: "48px",
      borderRadius: "50%",
      background: "#e5e5e5",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textDecoration: "none",
      color: "#111",
      fontSize: "24px",
    }}
  >
    ↓
  </a>
</div>
  
    <div className="row">
      <div className="col-lg-5">
        <h2
          style={{
            fontSize: "40px",
            lineHeight: "1.1",
            marginBottom: "40px",
          }}
>
          <strong>Your</strong> Approach
          <br />
          <strong>and</strong> Work Specifics
          </h2>

        <p
          style={{
            color: "#777",
            lineHeight: "1.6",
            fontSize: "17px",
          }}
        >
          We build brands from the inside out—combining strategy,
          research, and design to create clear, distinctive identities.
          From brand positioning and naming to logos, visual systems,
          and guidelines, our work ensures consistency, credibility,
          and long-term relevance across every brand touchpoint.
        </p>
        <div
  style={{
    display: "flex",
    alignItems: "center",
    gap: "20px",
    marginTop: "40px",
  }}
>
  <span
    style={{
      fontSize: "24px",
      fontWeight: "400",
      color: "#111",
    }}
  >
    View works
  </span>

  <a
    href="/portfolio"
    style={{
      width: "58px",
      height: "58px",
      borderRadius: "50%",
      background: "#e5e5e5",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textDecoration: "none",
      color: "#111",
      fontSize: "20px",
    }}
  >
    →
  </a>
</div>
      </div>

      <div className="col-lg-6 offset-lg-1">
        {services.map((service, index) => (
          <div key={index}>
            <div
              onClick={() => toggleAccordion(index)}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                cursor: "pointer",
                padding: "25px 0",
              }}
            >
              <h4
                style={{
                  margin: 0,
                  fontSize: "18px",
                }}
              >
                {service.title}
              </h4>
<div
  style={{
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    background: openIndex === index ? "#ff9800" : "#efefef",
    color: openIndex === index ? "#000" : "#666",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "20px",
    fontWeight: "300",
    transition: "all 0.3s ease",
  }}
>
  {openIndex === index ? "−" : "+"}
</div>

            </div>

            {openIndex === index && (
              <p
                style={{
                  color: "#777",
                  lineHeight: "1.5",
                  fontSize: "14px",
                  paddingBottom: "25px",
                }}
              >
                {service.content}
              </p>
            )}

            <hr />
          </div>
        ))}
      </div>
    </div>
  </section>
  <section
  style={{
    background: "#000",
    color: "#fff",
    padding: "120px 0",
    textAlign: "center",
    position: "relative",
  }}
>
  <div className="container">

    <h2
      style={{
        fontSize: "50px",
        lineHeight: "1.1",
        marginBottom: "30px",
      }}
    >
      <span style={{ fontWeight: "100", color: "#fff" }}>
        Where
      </span>{" "}
      <span style={{ fontWeight: "500", color: "#fff" }}>
        Creativity
      </span>{" "}
      <span style={{ fontWeight: "100", color: "#fff" }}>
        Meets
      </span>

      <br />

      <span style={{ fontWeight: "500", color: "#fff" }}>
        Strategic Execution
      </span>
    </h2>

    <p
      style={{
        maxWidth: "900px",
        margin: "0 auto 50px",
        color: "#bdbdbd",
        fontSize: "20px",
        lineHeight: "1.8",
      }}
    >
      Explore and gain a deeper understanding of the comprehensive
      range of services we offer, thoughtfully designed to meet your
      needs and deliver impactful, results-driven solutions across
      every stage of your business journey.
    </p>

    <a
      href="/contact"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "20px",
        background: "#ce5311",
        color: "#000",
        textDecoration: "none",
        padding: "20px 35px",
        borderRadius: "50px",
        fontWeight: "600",
        fontSize: "18px",
      }}
    >
      Contact Us

      <span
        style={{
          width: "50px",
          height: "50px",
          borderRadius: "50%",
          background: "#000",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        →
      </span>
    </a>

  </div>
</section>
<section
  style={{
    padding: "120px 0",
    background: "#f5f5f5",
  }}
>
  <div className="container">

    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "50px",
      }}
    >
      <h2 style={{ 
        margin: 0,
    fontSize: "40px",
    lineHeight: "1.1",
       }}>Other Services</h2>

      <a
        href="/services"
        style={{
          textDecoration: "none",
          color: "#111",
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}
      >
        View all
        <span
          style={{
            width: "35px",
            height: "35px",
            borderRadius: "50%",
            background: "#e5e5e5",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          →
        </span>
      </a>
    </div>

    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: "30px",
      }}
    >

      {/* Card 1 */}
      <div className="service-card">
        
      
        <h3 style={{
           marginBottom: "30px",
          fontSize: "30px",
          lineHeight: "1.1",
        }}>
          Creative Advertising & Campaigns
        </h3>

        <p style={{ lineHeight: "1.8", marginBottom: "30px" , fontSize: "14px"}}>
          Building compelling multi-channel campaigns that spark attention,
          drive engagement, and influence customer behaviour.
        </p>
      

        <hr />

        <p 
        style={{ margin: "14px 0",
           lineHeight: "1.6",
            color: "#111",
             fontSize: "14px",}}

        >Creative Concept Development</p>
        <hr />

        <p
         style={{ margin: "14px 0",
          lineHeight: "1.6",
          color: "#111",
          fontSize: "14px",}}
          >Integrated Advertising Campaigns</p>
        <hr />

        <p
        style={{ margin: "14px 0",
          lineHeight: "1.6",
          color: "#111",
          fontSize: "14px",}}
          >Print & Outdoor Advertising</p>
        <hr />

        <p
        style={{ margin: "14px 0",
          lineHeight: "1.6",
          color: "#111",
          fontSize: "14px",}}
        >Brand Films & Video Content</p>
        <hr />

        <p
        style={{ margin: "14px 0",
          lineHeight: "1.6",
          color: "#111",
          fontSize: "14px",}}
        >Event & Experiential Creative</p>
        <hr />

        <p
        style={{ margin: "14px 0",
          lineHeight: "1.6",
          color: "#111",
          fontSize: "14px",}}
         >Content & Copywriting</p>
      

        <a
          href="/services"
          style={{
            marginTop: "40px",
            display: "inline-flex",
            alignItems: "center",
            gap: "15px",
            textDecoration: "none",
            color: "#000000",
            fontWeight: "600",
          }}
        >
          Read more
          <span className="read-more-circle">
            →
          </span>
        </a>
      </div>

      {/* Card 2 */}
      <div className="service-card">
        
      
        <h3 style={{ 
          marginBottom: "30px",
          fontSize: "30px",
          lineHeight: "1.1",
          }}>
          Digital Marketing & Performance Growth
        </h3>

        <p style={{ lineHeight: "1.8", marginBottom: "30px", fontSize: "14px"}}>
          Driving measurable growth through targeted digital strategies,
          content, and performance-focused marketing solutions.
        </p>

        <hr />
        <p
        style={{ margin: "14px 0",
          lineHeight: "1.6",
          color: "#111",
          fontSize: "14px",}} >Social Media Marketing & Management</p>
        <hr />
        <p
         style={{ margin: "14px 0",
          lineHeight: "1.6",
          color: "#111",
          fontSize: "14px",}}
        >Performance Marketing & Paid Media</p>
        <hr />
        <p
         style={{ margin: "14px 0",
          lineHeight: "1.6",
          color: "#111",
          fontSize: "14px",}}
        >Search Engine Optimization (SEO)</p>
        <hr />
        <p
         style={{ margin: "14px 0",
          lineHeight: "1.6",
          color: "#111",
          fontSize: "14px",}}
        >Content Marketing Strategy</p>
        <hr />
        <p
         style={{ margin: "14px 0",
          lineHeight: "1.6",
          color: "#111",
          fontSize: "14px",}}
        >Email & Marketing Automation</p>
        <hr />
        <p
         style={{ margin: "14px 0",
          lineHeight: "1.6",
          color: "#111",
          fontSize: "14px",}}
        >Analytics, Insights & Optimization</p>

        <a
          href="/services"
          style={{
            marginTop: "40px",
            display: "inline-flex",
            alignItems: "center",
            gap: "15px",
            textDecoration: "none",
            color: "#111",
            fontWeight: "600",
          }}
        >
          Read more
          <span className="read-more-circle">
          →
          </span>
        </a>
      </div>

      {/* Card 3 */}
      <div className="service-card">
      
        <h3 style={{ 
          marginBottom: "30px",
          fontSize: "30px",
          lineHeight: "1.1",
         }}>
          Web, UI/UX & Digital Experiences
        </h3>

        <p style={{ lineHeight: "1.8", marginBottom: "30px" , fontSize: "14px"}}>
          Designing intuitive digital experiences that enhance brand
          presence and convert audience interactions effectively.
        </p>

              <hr />
      
        <p style={{ margin: "14px 0", 
        lineHeight: "1.6",
         color: "#111",
          fontSize: "14px"
        }}>Website Strategy & Information Architecture</p>
        <hr />
        <p style={{ margin: "14px 0", 
        lineHeight: "1.6",
         color: "#111",
          fontSize: "14px"
        }}>UI/UX Design</p>
        <hr />
        <p style={{ margin: "14px 0", 
        lineHeight: "1.6",
         color: "#111",
          fontSize: "14px"
        }}>Website Design & Development</p>
        <hr />
        <p style={{ margin: "14px 0", 
        lineHeight: "1.6",
         color: "#111",
          fontSize: "14px"
        }}>E-commerce Experiences</p>
        <hr />
        <p style={{ margin: "14px 0", 
        lineHeight: "1.6",
         color: "#111",
          fontSize: "14px"
        }}>Mobile App UI/UX Design</p>
        <hr />
        <p style={{ margin: "14px 0", 
        lineHeight: "1.6",
         color: "#111",
          fontSize: "14px"
        }}>Digital Product & Experience Design</p>

        <a
          href="/services"
          style={{
            marginTop: "40px",
            display: "inline-flex",
            alignItems: "center",
            gap: "15px",
            textDecoration: "none",
            color: "#111",
            fontWeight: "600",
          }}
        >
          Read more
          <span className="read-more-circle">
          →
          </span>
        </a>
      </div>

    </div>
  </div>
</section>

  <Footer />
</>

);
}

export default Branding;